<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <validation-observer ref="observer" v-slot="{ invalid, handleSubmit }">
          <b-form @submit.prevent="">
            <div class="form-card-wrapper">
              <b-card header-tag="header">
                <template #header>
                  <b>Contenuto</b>
                </template>
                <b-card-text>
                  <b-row>
                    <div class="mb-2 form-group" style="margin: 0">
                      <base-input
                        name="title"
                        vid="title"
                        label="Titolo"
                        v-model="form[rep].title"
                        placeholder="Inserisci un titolo"
                        @keyup="onInputTitle"
                        :rules="{ required: true }"
                      />
                      <div
                        class="custom-invalid-feedback"
                        style="
                          width: 100%;
                          margin-top: 0.25rem;
                          font-size: 0.875em;
                          color: #dc3545;
                        "
                        v-show="form[rep].title && !validName"
                      >
                        Esiste già un'immagine salvata con lo stesso titolo. Per
                        favore inserire un titolo differente per poter procedere
                        al salvataggio.
                      </div>
                    </div>
                  </b-row>
                  <b-row v-for="(item, index) in items" :key="index">
                    <div
                      class="col-m-6 mt-3 form-group d-flex align-items-center justify-content-between"
                    >
                      <base-form-file
                        v-model="item.file"
                        vid="base_form_file"
                        style="padding: 0; width: 290px"
                        :state="Boolean(item.file)"
                        placeholder="Scegli un file o trascinalo qui..."
                        drop-placeholder="Trascina il file qui..."
                        browse-text="Naviga"
                      ></base-form-file>
                      <b-button
                        size="sm"
                        class="mt-1 btn--transparent btn--smaller btn--x-smaller btn-reset"
                        @click="item.file = null"
                        :disabled="!item.file"
                      >
                        Reset
                      </b-button>
                    </div>
                  </b-row>
                </b-card-text>
              </b-card>
            </div>
            <div class="form-actions form-actions--sticky">
              <div class="inner-wrapper">
                <div>
                  <span
                    :title="`${
                      invalid
                        ? 'Compila correttamente i campi per poter salvare'
                        : 'Invia il form'
                    }`"
                  >
                    <b-button
                      @click="handleSubmit(onSubmit)"
                      type="button"
                      :disabled="invalid || (form[rep].title && !validName)"
                      variant="lisaweb"
                      size="sm"
                    >
                      Salva
                    </b-button>
                  </span>
                  <b-button
                    @click="resetForm()"
                    type="button"
                    class="btn--transparent btn-reset"
                    size="sm"
                    >Reset
                  </b-button>
                </div>
                <div>
                  <b-button
                    @click="$router.back()"
                    class="btn--transparent"
                    type="button"
                    title="Torna alla pagina precedente"
                  >
                    <b-icon-chevron-double-left
                      font-scale="0.9"
                    ></b-icon-chevron-double-left>
                    Torna indietro
                  </b-button>
                </div>
              </div>
            </div>
          </b-form>
        </validation-observer>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import ShortcutMixin from "@/mixins/ShortcutMixin";
import LisaComunicaMixin from "@/mixins/LisaComunicaMixin";
import BaseInput from "@/components/form/BaseInput";
import FormMixin from "../../../../mixins/FormMixin";
import BaseFormFile from "../../../form/BaseFormFile.vue";

export default {
  mixins: [FormMixin, ShortcutMixin, LisaComunicaMixin],
  data() {
    return {
      repository: "image",
      isLoading: false,
      validName: false,
      id: this.$route.params.id,
      form: {
        image: {
          title: null,
          image: null,
        },
      },
      fields: [
        {
          key: "filesystem",
          thStyle: {
            display: "none",
          },
          tdClass: "col-md-2",
        },
        {
          key: "delete",
          thStyle: {
            display: "none",
          },
          tdClass: "col-md-3",
        },
      ],
      items: [{ file: null }],
      image_list: [],
      image_list_titles: [],
    };
  },
  methods: {
    getImagesTitles() {
      this.image_list_titles = this.image_list.map((image) => image.title);
    },
    onInputTitle() {
      this.validName = this.form[this.rep].title
        ? !this.image_list_titles.includes(this.form[this.rep].title.trim())
        : false;
    },
    onSubmit() {
      this.isLoading = true;
      this.form[this.rep].image = this.items[0].file;
      let formData = new FormData();
      formData.append("title", this.form[this.rep].title);
      formData.append("image", this.form[this.rep].image);
      this.store(formData)
        .then(() => {
          this.isLoading = false;
          this.$showSnackbar({
            preset: "success",
            text: `Azione Completata: Immagine Caricata`,
          });
          this.shortcut("lisacomunica_template", null, "#Image", "filterImage");
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.isLoading = false;
        });
    },
  },
  components: {
    BaseFormFile,
    BaseInput,
  },
  computed: {
    rep() {
      return this.repository;
    },
  },
  mounted() {
    this.index("", "image")
      .then((response) => {
        this.image_list = response?.data?.content;
        if (this.image_list.length) this.getImagesTitles();
      })
      .catch((error) => {
        let errMsg = this.$getErrorMessage(error);
        this.$showSnackbar({
          preset: "error",
          text: `${errMsg}`,
        });
      });
  },
};
</script>

<style lang="scss" scoped>
:deep(tbody) {
  border-top: 0px !important;
}

:deep(table td) {
  border-top: 0px solid var(--color-border);
}
</style>
